import React, { useEffect } from "react";
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { findUser } from "../../store/userShow/actions/find-user";
import { HelperActions } from "./components/HelperActions";
import { findUserMessages } from "../../store/userShow/actions/find-user-messages";
import { findUserRoles } from "../../store/userShow/actions/findUserRoles";
import { HeaderSection } from "./components/HeaderSection";
import { SegmentsSection } from "./components/SegmentsSection";
import { findDocuments } from "../../store/userShow/actions/findDocuments";
import { findTemplatesForUser } from "../../store/templateList/actions/findTemplatesForUser";
import { findUserTemplateList } from "../../store/userTemplate/actions/findUserTemplateList";

export const UserShow: React.FC = () => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  useEffect(() => {
    const findData = async () => {
      await dispatch(findUser(Number(id)));
      dispatch(findUserMessages(Number(id)));
      dispatch(findUserRoles(Number(id)));
      dispatch(findDocuments());
      dispatch(findTemplatesForUser());
      dispatch(findUserTemplateList(id));
    };
    findData();
  }, [dispatch, id]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Usuarios" : ""}
              defaultHref="/app/rrhh/usuarios"
              color="light"
            />
          </IonButtons>
          <IonTitle>Usuario</IonTitle>
          <IonButtons slot="end">
            <HelperActions />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Usuario</IonTitle>
          </IonToolbar>
        </IonHeader>
        <HeaderSection />
        <SegmentsSection />
      </IonContent>
    </IonPage>
  );
};
